// given an emoji id, returns the url to render it
export const getEmojiImageUrl = (id: string) => {
  return `/blockly/media/dance/ai/emoji/${id}.svg`;
};
